// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import GetShopArticlePriceRequestModel from '../../model/get-shop-article-price-request-model';
import GetShopArticlePriceRequestDTO from '../dto/get-shop-article-price-request-dto';
import dtoSchema from '../schemas/get-shop-article-price-request-schema';

export default abstract class GetShopArticlePriceRequestModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<GetShopArticlePriceRequestDTO>) {
    super();
    if (data) {
      this.id = data.id;
      this.userId = data.userId;
    }
  }
  /**
  * @type {int64}
  */
  id?: number;
  /**
  * @type {int64}
  */
  userId?: number;

  static toModel(dto: DeepPartial<GetShopArticlePriceRequestDTO>): GetShopArticlePriceRequestModel;
  static toModel(dto: DeepPartial<GetShopArticlePriceRequestDTO> | undefined | null): GetShopArticlePriceRequestModel | undefined;
  static toModel(dto: DeepPartial<GetShopArticlePriceRequestDTO> | undefined | null): GetShopArticlePriceRequestModel | undefined {
    return dto ? new GetShopArticlePriceRequestModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<GetShopArticlePriceRequestModel> | GetShopArticlePriceRequestModel): GetShopArticlePriceRequestDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      id: unwrapped.id,
      userId: unwrapped.userId,
    } as GetShopArticlePriceRequestDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for GetShopArticlePriceRequestModel, can not map to GetShopArticlePriceRequestDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
